import { createContext, useState, useEffect, useContext } from "react";
import React from "react";
const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (localStorage.getItem("cart")) {
      const products = JSON.parse(localStorage.getItem("cart"));
      setProducts(products);
    }
  }, []);

  useEffect(() => {
    let sub = 0;
    let tot = 0;

    for (let i = 0; i < products.length; i++) {
      sub += products[i].price * products[i].cantidad;
      tot += products[i].price;
    }
    setSubtotal(sub);
    setTotal(tot);
  }, [products]);

  const addProduct = (product) => {
    let cantidad = 0;

    const { id } = product;

    try {
      let actualProducts = [];
      if (localStorage.getItem("cart")) {
        actualProducts = JSON.parse(localStorage.getItem("cart"));
      }

      let flag = false;

      for (let i = 0; i < actualProducts.length; i++) {
        if (actualProducts[i].id === id) {
          flag = true;
          cantidad = actualProducts[i].cantidad + 1;

          actualProducts[i].cantidad = cantidad;
          break;
        }
      }

      if (flag) {
        localStorage.setItem("cart", JSON.stringify(actualProducts));
        setProducts(actualProducts);
      } else {
        let newProduct = {
          id: id,
          cantidad: 1,
          name: product.name,
          price: product.price,
          image_url: product.image_url,
          description: product.description,
        };
        actualProducts.push(newProduct);
        localStorage.setItem("cart", JSON.stringify(actualProducts));
        setProducts(actualProducts);
      }
    } catch (err) {
      //// TODO : HANDLE ERROR
    }
  };

  const removeProduct = (product) => {
    let actualProducts = JSON.parse(localStorage.getItem("cart"));
    let newProducts = [];

    for (let i = 0; i < actualProducts.length; i++) {
      if (actualProducts[i].id !== product.id) {
        newProducts.push(actualProducts[i]);
      }
    }
    localStorage.setItem("cart", JSON.stringify(newProducts));
    setProducts(newProducts);
  };

  const changeQuantity = (product, cantidad) => {
    let actualProducts = JSON.parse(localStorage.getItem("cart"));
    let newProducts = [];

    for (let i = 0; i < actualProducts.length; i++) {
      if (actualProducts[i].id === product.id) {
        actualProducts[i].cantidad = cantidad;
        newProducts.push(actualProducts[i]);
      } else {
        newProducts.push(actualProducts[i]);
      }
    }

    localStorage.setItem("cart", JSON.stringify(newProducts));
    setProducts(newProducts);
  };

  const clear = () => {
    localStorage.removeItem("cart");
  };

  return (
    <CartContext.Provider
      value={{
        subtotal,
        total,
        products,
        addProduct,
        removeProduct,
        changeQuantity,
        clear,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCartContext = () => useContext(CartContext);
